<div class="inputfield">
  <input [formControlName]="formControlName" [type]="type" class="input" [ngClass]="clazz" [placeholder]="placeHolder"
         [name]="name"/>
</div>
